(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vf-purchase"] && !Shopify.designMode) return;
  try {
    class VfPurchase extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-plan-input]');
      this.querySelectorAll('input[type="radio"]').forEach((r) =>
        r.addEventListener('change', () => {
          if (!this.input || !r.checked) return;
          this.input.disabled = r.value === '';
          if (r.value) this.input.value = r.value;
        })
      );
    }
  }

  if (!customElements.get('vf-purchase')) customElements.define('vf-purchase', VfPurchase);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vf-tiers"] && !Shopify.designMode) return;
  try {
    class VfTiers extends HTMLElement {
    connectedCallback() {
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.radios.forEach((r) => r.addEventListener('change', () => r.checked && this.push(r.value)));
      requestAnimationFrame(() => {
        this.selector = document
          .getElementById(this.dataset.formId)
          ?.closest('product-form-component')
          ?.querySelector('quantity-selector-component');
        // Horizon fires this from +/- and when a typed value is committed.
        this.selector?.addEventListener('quantity-selector:update', (e) => this.pull(e.detail.quantity));
        const start = this.radios.find((r) => r.checked);
        if (start) this.push(start.value);
      });
    }

    // Tier picked: set the theme's quantity selector to match.
    push(qty) {
      if (!this.selector) return;
      this.selector.setValue(qty);
      this.selector.updateButtonStates?.();
    }

    // Quantity typed or stepped: select the highest tier it reaches.
    pull(value) {
      const qty = Number(value) || 1;
      let match = this.radios[0];
      this.radios.forEach((r) => {
        if (qty >= Number(r.value)) match = r;
      });
      match.checked = true;
    }
  }

  if (!customElements.get('vf-tiers')) customElements.define('vf-tiers', VfTiers);
  } catch(e) { console.error(e); }
})();

})();
